import { CommonModule, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { FilterContentComponent } from '@app/library/panes/filter-content/filter-content.component';
import { AbstractPane } from '@app/library/panes/models/abstract-pane';
import { UserServiceCardFullModule } from '@app/meetings/user-service-card-full/user-service-card-full.module';
import { EmptyComponent, EmptyProps } from '@core/components/empty/empty.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { UserServiceCardModule } from '@core/components/service-card/user-service-card.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { HelpersBffService } from '@core/services/bff/helpers.service';
import { Store } from '@ngrx/store';

import { UserService } from 'lingo2-models';
import { InViewportModule } from 'ng-in-viewport';
import { UserServiceSurfaceBlockComponent } from '../../../meetings/user-service-card-full/user-service-surface-block/user-service-surface-block.component';

@Component({
  selector: 'app-favorites-services',
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    SpinnersModule,

    InViewportModule,
    UserServiceCardModule,
    ModalModule,
    MobileModalModule,
    UserServiceCardFullModule,
    FilterContentComponent,
    EmptyComponent,
    UserServiceSurfaceBlockComponent,
  ],
  templateUrl: './favorites-services.component.html',
  styleUrls: ['./favorites-services.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoritesServicesComponent extends AbstractPane {
  protected location = inject(Location);
  private helpers = inject(HelpersBffService);
  protected readonly store = inject(Store);

  public filterTabs = [
    {
      id: -1,
      code: null,
      title: 'meetings.titles.for_all',
    },
    {
      id: 1,
      code: 3,
      title: 'meetings.titles.exam_training',
    },
    {
      id: 2,
      code: 4,
      title: 'meetings.titles.for_children',
    },
    {
      id: 3,
      code: 2,
      title: 'meetings.titles.speaking',
    },
    {
      id: 5,
      code: 5,
      title: 'meetings.titles.discussion',
    },
    {
      id: 6,
      code: 7,
      title: 'meetings.titles.master_class',
    },
  ];
  public selectedTab = this.filterTabs[0];
  public userServiceCardFullInModal: boolean;
  public openedUserService: UserService;
  public surfaceBlockDisplay: boolean;
  private originalUrl: string;
  public emptyObj: Partial<EmptyProps> = {
    text: 'favorites.empty-message',
    image: 'favorites',
    link_label: 'favorites/services.empty',
    link: '/classes',
    link2: '/classes',
  };

  hasContent(): boolean {
    return true;
  }

  protected onContentLoaded(viaQuery?: boolean) {
    this.isVisible = true;
  }

  public onInViewportBottomChange(reached) {
    if (reached.visible) {
      this.loadNextPage();
    }
  }

  protected onSelectItem(item) {
    if (this.selectedTab.id === item.id) {
      return;
    }
    this.selectedTab = item;

    this._pane = {
      ...this._pane,
      loaded: false,
      userServiceFilter: {
        ...this._pane.userServiceFilter,
        category_id: this.selectedTab.code,
      },
      userServices: [],
    };

    this.loadPane();
  }

  public onToggleUserServiceInModal(userService: UserService = null) {
    this.openedUserService = userService;
    this.userServiceCardFullInModal = !this.userServiceCardFullInModal;
    this.setAndResetUrl();
    this.detectChanges();
  }

  public onIinViewportChange(e) {
    this.surfaceBlockDisplay = e;
    this.detectChanges();
  }

  public onFavoriteChanged(index: number) {
    this.userServices.splice(index, 1);
  }

  public trackByFn(index, item: UserService): string {
    return item.id;
  }

  private setAndResetUrl() {
    const url = this.helpers.userServiceRouteUniversal(this.openedUserService);
    const currentUrl = this.location.path(false);
    if (this.userServiceCardFullInModal) {
      if (currentUrl !== url) {
        if (!this.originalUrl) {
          this.originalUrl = currentUrl;
        }
        this.location.replaceState(url);
      }
    } else {
      if (this.originalUrl) {
        this.location.replaceState(this.originalUrl);
        this.originalUrl = null;
      }
    }
  }
}
